import React, { Component } from 'react';

class InputWrap extends Component {

    render() {      
        return (
            <div className={"input-wrap" + (this.props.error != null ? ' error' : '') + ((this.props.value ?? '').length > 0 ? ' filled' : '')}>
                 {this.props.children}
                 <label>{this.props.label}</label>
                {this.props.error != null ? 
                <div className="error">
                    {this.props.error}
                </div> : ''
                }
            </div>
        );
    }
}

export default InputWrap;

